import type { GeometryDimensions } from '../types/mathGeometry';

export function regularPolygonCircumradius(sideLength: number, sides: number): number {
  const n = Math.max(3, sides);
  return sideLength / (2 * Math.sin(Math.PI / n));
}

export function regularPolygonWorldBounds(dimensions: GeometryDimensions) {
  const sides = Math.max(3, Math.round(Number(dimensions.sides) || 5));
  const sideLength = Number(dimensions.sideLength) || 2;
  const radius = regularPolygonCircumradius(sideLength, sides);
  return {
    minX: -radius,
    minY: -radius,
    maxX: radius,
    maxY: radius,
    sides,
    sideLength,
    radius,
  };
}

export function regularPolygonSvgPoints(
  cx: number,
  cy: number,
  radius: number,
  sides: number,
): string {
  const n = Math.max(3, sides);
  const points: string[] = [];
  for (let i = 0; i < n; i += 1) {
    const angle = -Math.PI / 2 + (2 * Math.PI * i) / n;
    const x = cx + radius * Math.cos(angle);
    const y = cy + radius * Math.sin(angle);
    points.push(`${x},${y}`);
  }
  return points.join(' ');
}
